<!--资源中心菜单-->
<template>
    <div class="menu-container">
        <div @click="changeItem('1')" :class="activeItem==='1'?'menu-item menu-active':'menu-item'">高水平示范课</div>
        <div @click="changeItem('2')" :class="activeItem==='2'?'menu-item menu-active':'menu-item'">区本课程</div>
        <div @click="changeItem('3')" :class="activeItem==='3'?'menu-item menu-active':'menu-item'">校本课程</div>
        <div @click="changeItem('4')" :class="activeItem==='4'?'menu-item menu-active':'menu-item'">课后服务</div>
        <div @click="changeItem('5')" :class="activeItem==='5'?'menu-item menu-active':'menu-item'">人工智能</div>
        <div @click="changeItem('6')" :class="activeItem==='6'?'menu-item menu-active':'menu-item'">互动课件</div>
        <div @click="changeItem('7')" :class="activeItem==='7'?'menu-item menu-active':'menu-item'">恒岳助教</div>
        <div v-if="role==1||role==2||isRwmy==1" @click="changeItem('8')" :class="activeItem==='8'?'menu-item menu-active':'menu-item'">人文美育</div>
        <div @click="changeItem('20')" :class="activeItem==='20'?'menu-item menu-active':'menu-item'">博雅美育</div>
        <div @click="changeItem('21')" :class="activeItem==='21'?'menu-item menu-active':'menu-item'">小学资源</div>
        <div @click="changeItem('22')" :class="activeItem==='22'?'menu-item menu-active':'menu-item'">初中资源</div>
        <div @click="changeItem('23')" :class="activeItem==='23'?'menu-item menu-active':'menu-item'">高中资源</div>
        <div @click="changeItem('9')" :class="activeItem==='9'?'menu-item menu-active':'menu-item'">国家智慧教育云平台</div>
    </div>
</template>

<script>

export default {
    name:'courseMenuOld',
    components:{},
    props:{
        itemNum:{
            type: String,
            default:"1"
        },
        studioNature:{
            type: String,
            default:"2"
        },
    },
    watch:{
        itemNum(newValue,oldValue){
            this.activeItem = newValue;
        },
    },
    mounted() {},
    data() {
        return {
            activeItem:"1",
            role:this.$storage.get("role"),
            isRwmy:JSON.parse(this.$storage.get("userInfo")).isRwmy,
        }
    },
    methods: {
        changeItem(item){
            this.activeItem = item;
            this.$emit('change-item', item );
        },

    }
}

</script>

<style scoped>
.menu-container{
    /*width: 100%;*/
    height: calc(100vh - 120px);
    background: #dfe4f7;
    padding-top: 15px;
    padding-bottom: 15px;
    border-radius: 10px;
    width: 180px!important;
    position: fixed;
    top: 80px;
    z-index: 999;
    overflow-y: auto;
}
.menu-container::-webkit-scrollbar{width:0!important}
.menu-item{
    width: 100%;
    height: 50px;
    line-height: 50px;
    text-indent: 15px;
    font-size: 15px;
    color: #707070;
    cursor: pointer;
}
.menu-active{
    background: #0d55a4;
    color: #fff;
    //font-weight: bold;
}
</style>